import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';
import UserSettingsNestedPage from 'layouts/nested/user/UserSettingsNestedPage';


const userRoutes = [
  {
    path: '/profile',
    component: UserSettingsNestedPage,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Profile')
      }
    },
    children: [
      {
        path: '',
        name: 'userInfo',
        component: wrapLegacyRoute('usersController', 'userInfo')
      },
      {
        path: 'settings',
        name: 'userSettings',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Settings')
          }
        },
        component: wrapLegacyRoute('usersController', 'userSettings')
      },
      {
        path: 'sessions',
        name: 'userSessions',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Sessions')
          }
        },
        component: wrapLegacyRoute('usersController', 'userSessions')
      }
    ]
  }
];


export default userRoutes;
